import nav from '../libs/nav';
import logo from '../libs/logo';
import bottleComponent from '../libs/bottle_component';
import aos from '../libs/aos';
import animage from '../libs/animage';
import loader from '../libs/loader';
import share from '../libs/share';
import fullScrollBottles from '../libs/full_scroll_bottles';
import jquerySmoothwheel from '../libs/jquery_smoothwheel';


export default
    {
        init() {
        },

        finalize() {
            loader();
            logo();
            nav();
            aos();
            share();
            fullScrollBottles();
            jquerySmoothwheel();
            animage();
        },
    }


// WEBPACK FOOTER //
// ./scripts/routes/common.js